import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchUsers = createAsyncThunk("users/fetchUsers", async () => {
  const response = await apiCustom.get("/user-shows");
  return response.data?.data;
});
export const fetchUsersPublic = createAsyncThunk(
  "users/fetchUsersPublic",
  async () => {
    const response = await apiCustom.get("/user-shows-public");
    return response.data?.data;
  }
);
export const saveUser = createAsyncThunk(
  "users/saveUser",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/user-create", newPost, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateUser = createAsyncThunk(
  "users/updateUser",
  async ({ id, userData }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/user-update`, userData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete("/user-destroy", {
        data,
        headers: {
          "Content-Type": "application/json",
        },
      });
      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

export const showUserById = createAsyncThunk(
  "users/showUserById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get("/user-show/" + id);
      return response.data?.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    authUsers: [],
    user: [],
    status: "idle",
    authUsersStatus: "idle",
    error: null,
    authUsersError: null,
  },
  reducers: {
    setUsers: (state, action) => {
      const index = state.users.findIndex(
        (user) => user.id === action.payload.id
      );
      if (index !== -1) {
        state.users[index] = action.payload;
      } else {
        state.users.push(action.payload);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.authUsersStatus = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.authUsersStatus = "succeeded";
        state.authUsers = action.payload;
      })
      .addCase(fetchUsersPublic.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.authUsersStatus = "failed";
        state.authUsersError = action.payload;
      })
      .addCase(saveUser.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(showUserById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = [action.payload];
      });
  },
});

export const { setUsers } = usersSlice.actions;
export default usersSlice.reducer;
